import React from 'react';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DARK_MODE_DATE_CALENDAR_ICON = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'%23e0e0e0\' viewBox=\'0 0 24 24\'%3E%3Cpath d=\'M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z\'/%3E%3C/svg%3E")';

export function DateFilterTextField({ InputProps, ...props }) {
    const theme = useTheme();
    const darkDateInputSx = theme.palette.mode === 'dark'
        ? {
            '& input[type="date"]': {
                colorScheme: 'dark'
            },
            '& input[type="date"]::-webkit-calendar-picker-indicator': {
                appearance: 'none',
                WebkitAppearance: 'none',
                backgroundImage: DARK_MODE_DATE_CALENDAR_ICON,
                backgroundSize: '16px 16px',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                color: 'transparent',
                opacity: 1,
                width: '16px',
                height: '16px',
                cursor: 'pointer'
            }
        }
        : null;

    return (
        <TextField
            {...props}
            InputProps={{
                ...InputProps,
                sx: darkDateInputSx
                    ? [darkDateInputSx, InputProps?.sx].filter(Boolean)
                    : InputProps?.sx
            }}
        />
    );
}

export const auditLogClearFiltersButtonSx = (theme) => ({
    ...(theme.palette.mode === 'dark' && {
        color: theme.palette.text.primary,
        borderColor: theme.palette.quote_stepper.inactiveBorder,
        '&:hover': {
            borderColor: theme.palette.primary.light,
            backgroundColor: 'rgba(255, 255, 255, 0.08)'
        }
    })
});
